import { render, staticRenderFns } from "./taskhistory.vue?vue&type=template&id=12e20e83&scoped=true"
import script from "./taskhistory.vue?vue&type=script&lang=js"
export * from "./taskhistory.vue?vue&type=script&lang=js"
import style0 from "./taskhistory.vue?vue&type=style&index=0&id=12e20e83&prod&lang=css"
import style1 from "./taskhistory.vue?vue&type=style&index=1&id=12e20e83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e20e83",
  null
  
)

export default component.exports